import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from './../services/authentication.service';
import { Globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardRouteConfigService implements CanActivate {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private globals: Globals
  ) {
    console.log('AuthGuardRouteConfigService');
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;

    let Id = route.params.Id;

    let havePerm: boolean;

    if (Id === '0') { // creacion
      havePerm = this.globals.perms.some((x) => {
        return x.Name === 'G_CreateRoute';
      });
    } else { // edicion
      havePerm = this.globals.perms.some((x) => {
        return x.Name === 'G_EditRoute';
      });
    }

    let expires = new Date(currentUser.ExpireTime);
    let today = new Date();

    if (currentUser && (today <= expires)) { // posee token y el mismo aun no expira
      if (havePerm) { // tiene permiso para ingresar a la pagina de ruta
        return true;
      } else { // no tiene permiso para ingresar a la pagina de ruta
        this.router.navigate(['/home']);
        return false;
      }
    }

    this.authenticationService.logout();
    return false;
  }
}
